import Backend from 'backend';
import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {ValidationController, ValidationRules} from "aurelia-validation";

@inject(Backend, Router, ValidationController)
export class CustomerUserEditScreen {
    backend;

    // To be posted
    editCustomerUser;

    router;
    validationController;

    constructor(backend, router, validationController) {
        this.backend = backend;
        this.router = router;
        this.validationController = validationController;
    }

    activate(params) {
        this.customerId = params.customerId;
        this.customerUserId = params.customerUserId;
        this.backend.CustomerUserCrud_getForEdit(this.customerUserId)
          .then(result => {
            this.editCustomerUser = result.customerUserEditDto;
          })
    }

    bind() {
      // ValidationRules
            // .ensure('discountRate')
            //   .displayName('Rabatt')
            //   .satisfies(value => !value || numeral.validate(value, 'en'))
            //   .withMessage('Rabatt må være et tall')
            // .on(this.editCustomerUser);
    }

    submit() {
      return this.validationController.validate()
        .then(result => {
          if (!result.valid) {
            return;
          }

          return this.backend.CustomerUserCrud_edit(this.customerUserId, this.editCustomerUser)
            .then(() => this.router.navigateToRoute("customer-details", { customerId: this.customerId}));
        });
    }
}
